export default "__VITE_ASSET__DVMv$Xv$__"